// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _forTrack0 = ($index, $item) => $item.id;
function GuidedWorkflowsCategoriesComponent_For_3_For_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function GuidedWorkflowsCategoriesComponent_For_3_For_15_Template_a_click_0_listener() { const subcategory_r5 = i0.ɵɵrestoreView(_r4).$implicit; const category_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectSteps(category_r2, subcategory_r5)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subcategory_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(subcategory_r5.title);
} }
function GuidedWorkflowsCategoriesComponent_For_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵlistener("click", function GuidedWorkflowsCategoriesComponent_For_3_Template_div_click_1_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleCategory(category_r2)); });
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 7)(6, "div", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 10);
    i0.ɵɵelement(11, "div", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 12)(13, "div", 13);
    i0.ɵɵrepeaterCreate(14, GuidedWorkflowsCategoriesComponent_For_3_For_15_Template, 2, 1, "a", 14, _forTrack0);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    i0.ɵɵclassProp("active", category_r2.expanded);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("background-color", category_r2.background_color);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(category_r2.icon);
    i0.ɵɵproperty("name", category_r2.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(category_r2.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r2.description);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("collapse", !category_r2.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(category_r2.subcategories);
} }
/**
 *
 * Guided Workflows Categories Component
 *  Displays expandeable categories and subcategories of guided workflows.
 *  Clicking a subcategory should display steps content instead.
 *
 * Input Properties:
 *   expandableCategories: list of ExpandablePageGuidedWorkflows to display.
 *   steps: list of GuidedWorkflowStep to display.
 *   selectedCategory: Expanded category

 *
 * Output Properties:
 *   stepsChange: EventEmitter to emit the steps.
 *   selectedCategoryChange: EventEmitter to emit the selected category.
 *   selectedSubcategory: EventEmitter to emit the selected subcategory.
 *
 */
export class GuidedWorkflowsCategoriesComponent {
    constructor() {
        this.expandableCategories = [];
        this.selectedCategory = null;
        this.stepsChange = new EventEmitter();
        this.selectedCategoryChange = new EventEmitter();
        this.selectedSubcategory = new EventEmitter();
    }
    toggleCategory(category) {
        // eslint-disable-next-line no-param-reassign
        category.expanded = !category.expanded;
        this.selectedCategoryChange.emit(category);
    }
    selectSteps(category, subcategory) {
        this.selectedCategoryChange.emit(category);
        this.selectedSubcategory.emit(subcategory);
        this.stepsChange.emit(subcategory.steps);
    }
}
GuidedWorkflowsCategoriesComponent.ɵfac = function GuidedWorkflowsCategoriesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsCategoriesComponent)(); };
GuidedWorkflowsCategoriesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedWorkflowsCategoriesComponent, selectors: [["ycn-guided-workflows-categories"]], inputs: { expandableCategories: "expandableCategories", steps: "steps", selectedCategory: "selectedCategory" }, outputs: { stepsChange: "stepsChange", selectedCategoryChange: "selectedCategoryChange", selectedSubcategory: "selectedSubcategory" }, standalone: false, decls: 4, vars: 0, consts: [[1, "mb-2", "mt-2", "text-gray-30"], [1, "card", "card-hover", "bg-white", "mb-row", 2, "padding", "0", 3, "active"], [1, "card", "card-hover", "bg-white", "mb-row", 2, "padding", "0"], [1, "d-flex", "card-md", 3, "click"], [1, "card-sidebar", "pr-2"], [1, "card-sidebar-icon"], ["ycnIcon", "", 3, "name"], [1, "card-body"], [1, "card-title", "pb-4px"], [1, "text-small", "text-gray-50"], [1, "card-sidebar", "pl-2"], [1, "card-collapse-toggler", "collapse-chevron", "rotate-90"], [1, "card-collapse"], [1, "card-collapse-menu"], ["href", "javascript:void(0)", 1, "card-collapse-menu-item"], ["href", "javascript:void(0)", 1, "card-collapse-menu-item", 3, "click"]], template: function GuidedWorkflowsCategoriesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p", 0);
        i0.ɵɵtext(1, "Here are some ways to get started.");
        i0.ɵɵelementEnd();
        i0.ɵɵrepeaterCreate(2, GuidedWorkflowsCategoriesComponent_For_3_Template, 16, 11, "div", 1, _forTrack0);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.expandableCategories);
    } }, dependencies: [i1.IconDirective], encapsulation: 2 });
